<script>
import MegaNav from './MegaNav'
import SubNav from './SubNav'
import MenuToggle from './MenuToggle'
import { messageSuccess } from '@utils/message'
import MobileSearch from './MobileSearch'

// import { BRAND_MENU, SOLUTION_MENU, PRODUCT_MENU } from "@src/config/fake-data";
import { authComputed, globalComputed, optionComputed } from '@store/helpers'

export default {
  components: {
    MenuToggle,
    MegaNav,
    SubNav,
    MobileSearch,
  },
  props: {
    type: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'liff', 'brand'].includes(value)
      },
    },
    brandContact: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      subMenuPage: {
        title: '',
        alias: '',
        description: '',
        list: [],
      },
      productSubMenuPage: {
        title: '',
        alias: '',
        list: [],
        category: '',
      },
      showMobileMenu: false,
      email: '',
      tryingSubscription: false,
      isMobileSearchOpen: false,
      techInside: {
        text: '主題策展',
        url: 'https://www.zerone.com.tw/campaign/2024techinside',
      },
    }
  },
  computed: {
    ...authComputed,
    ...globalComputed,
    ...optionComputed,
    diaplayMenuLength() {
      return this.menuList
    },
    menuList() {
      let resultArr = [
        {
          text: '最新消息',
          to: {
            name: 'news-list',
          },
          type: 'nav',
          children: [
            {
              text: '品牌新訊',
              to: {
                name: 'news-category',
                params: {
                  categoryAlias: 'bulletin',
                },
              },
            },
            {
              text: '促銷訊息',
              to: {
                name: 'news-category',
                params: {
                  categoryAlias: 'promotion',
                },
              },
            },
          ],
        },
        {
          text: '產品服務',
          to: {
            name: 'brand',
          },
          type: 'mega',
          data: {
            list: [
              {
                text: '代理品牌',
                alias: 'brands',
                to: {
                  name: 'brand-list',
                },
                data: {
                  // productlist: this.productCategory,
                  list: this.brandList,
                },
                type: 'mega',
              },
              {
                text: '產品系列',
                alias: 'products',
                to: {
                  name: 'product-list',
                },
                data: {
                  list: this.productCategory,
                  // brands: this.$store.state.global.menuBrand,
                },
                type: 'mega',
              },
              {
                text: '共同供應契約採購',
                to: {
                  name: 'bot-list',
                },
              },
              {
                text: '雲端服務網',
                type: 'link',
                path: 'https://csp.zerone.com.tw/',
              },
              {
                text: 'ZOiPS數位監控',
                type: 'link',
                path: 'http://www.zoips.com.tw/',
              },
              {
                text: 'AOD',
                type: 'link',
                path: 'https://www.aod.com.tw/zh-tw/',
              },
              {
                text: '零壹資安保母服務',
                type: 'link',
                path: 'https://www.zerone.com.tw/edm/2025/ZeroOneCare/index.html',
              },
            ],
            type: 'a',
          },
        },
        {
          text: '課程活動',
          to: {
            name: 'event-list',
          },
          type: 'nav',
        },
        // {
        //   text: '解決方案',
        //   to: {
        //     name: 'solution-list'
        //   },
        //   type: 'nav',
        // },
        {
          text: '影片專區',
          to: {
            name: 'video-list',
          },
          type: 'nav',
        },
        // {
        //   text: '主題策展',
        //   to: {
        //     name: 'techInside-home',
        //   },
        //   type: 'insideLink',
        // },
      ]
      // if (window.globalData.curation === '1') {
      //   resultArr.push({
      //     text: '主題策展',
      //     to: {
      //       name: 'techInside-home',
      //     },
      //     type: 'insideLink',
      //   })
      // }
      return resultArr
    },
    mobileMenuList() {
      return [
        {
          text: '關於零壹',
          type: 'nav',
          children: [
            {
              text: '公司簡介',
              to: {
                name: 'about-zerone',
              },
            },
            {
              text: '經營團隊',
              to: {
                name: 'about-organization',
              },
            },
            {
              text: '零壹大事紀',
              to: {
                name: 'about-history',
              },
            },
          ],
        },
        {
          text: '聯絡我們',
          type: 'nav',
          children: [
            {
              text: '業務洽詢',
              to: {
                name: 'inquiry',
              },
            },
            {
              text: '聯絡銷售人員',
              to: {
                name: 'contactSales',
              },
            },
            {
              text: '營業據點',
              to: {
                name: 'location',
              },
            },
            {
              text: '維修服務',
              to: {
                name: 'repair',
              },
            },
            {
              text: '會員帳號服務',
              to: {
                name: 'inquiryOther',
              },
            },
          ],
        },
        {
          text: '投資人專區',
          type: 'nav',
          children: [
            {
              text: '財務資訊',
              to: {
                name: 'investor-finance',
              },
            },
            {
              text: '公司治理',
              to: {
                name: 'investor-companypolicy',
              },
            },
            {
              text: '利害關係人專區',
              to: {
                name: 'investor-int',
              },
            },
            {
              text: '股東專欄',
              to: {
                name: 'investor-shareholders',
              },
            },
          ],
        },
        {
          text: '網站資訊',
          type: 'nav',
          children: [
            {
              text: '網站地圖',
              to: {
                name: 'site-map',
              },
            },
            // {
            //   text: '訂閱電子報',
            //   to: {
            //     name: 'subscription'
            //   }
            // },
            // {
            //   text: '檔案下載',
            //   to: {
            //     name: 'file'
            //   }
            // },
            // {
            //   text: '常見問答',
            //   to: {
            //     name: 'faq'
            //   }
            // },
            {
              text: '隱私權與服務條款',
              to: {
                name: 'privacy',
              },
            },
          ],
        },
        {
          text: '菁英招募',
          type: 'nav',
          children: [
            {
              text: '加入零壹',
              to: {
                name: 'elite-join',
              },
            },
            {
              text: '成長在零壹',
              to: {
                name: 'elite-grow',
              },
            },
            {
              text: '生活在零壹',
              to: {
                name: 'elite-live',
              },
            },
          ],
        },
      ]
    },
    invalid() {
      return !/^\S+@\S+\.\S+/.test(this.email)
    },
    foramtLineId() {
      return (this.currentSetting.lineId || '').replace('@', '')
    },
    displayBackkey() {
      const pageRouteMap = () => [
        'news-item',
        'product-item',
        // 'event-item',
        'event-apply',
        'solution-item',
        'video-item',
        'brand-news-list',
        'brand-news-category',
        'brand-product-list',
        'brand-solution-list',
        'brand-case-list',
        'brand-event-list',
        'brand-file',
        'brand-video-list',
        'brand-news-item',
        'brand-product-item',
        'brand-solution-item',
        'brand-case-item',
        'brand-event-item',
        'brand-video-item',
        'brand-introduce',
        'member-info',
        'member-setting',
        'member-activity-list',
        'member-activity-item',
        'member-event-list',
        'member-event-item',
        'member-event-item-live',
        'member-coupon-list',
      ]
      return pageRouteMap().includes(this.$route.name)
    },
    brandList() {
      return this.brand.filter((item) => {
        return item.alias !== 'zerone'
      })
    },
  },
  // mounted() {
  //   if (window.globalData.curation === '1') {
  //     this.menuList.push({
  //       text: '主題策展',
  //       to: {
  //         name: 'techInside-home',
  //       },
  //       type: 'insideLink',
  //     })
  //   }
  // },
  methods: {
    onChangeMenuPage({ title, alias, description, list, name }) {
      this.subMenuPage = {
        title,
        alias,
        description,
        list,
        name,
      }
    },
    goTo(alias) {
      const router = () => {
        switch (this.subMenuPage.name) {
          case 'brand-list':
            return {
              name: 'brand-item',
              params: {
                brandAlias: alias,
              },
            }
          case 'product-list':
            return {
              name: 'product-list',
              query: {
                filterCategory: this.productSubMenuPage.category,
                filterBrand: alias,
              },
            }
          case 'solution-list':
            return {
              name: 'solution-list',
              query: {
                filterCategory: this.subMenuPage.alias,
                filterClass: alias,
              },
            }
        }
      }
      return {
        ...router(),
      }
    },
    async onSubscription() {
      this.tryingSubscription = true

      await this.$store
        .dispatch('global/subscribe', {
          email: this.email,
          newsletterCategoriesAlias: ['01_newsletter'],
        })
        .then(() => {
          this.tryingSubscription = false

          messageSuccess('已成功訂閱！')
        })
    },
    mobileSearchOpen(status) {
      this.isMobileSearchOpen = status
      this.showMobileMenu = false
    },
    showMobileMenuOpen(status) {
      this.showMobileMenu = status
      this.isMobileSearchOpen = false
    },
    onChangeSubMenuPage({ title, alias, list, name, category }) {
      this.productSubMenuPage = {
        title,
        alias,
        list,
        name,
        category,
      }
    },
    goToProductCategory(item) {
      this.$router.push({
        name: 'product-list',
        query: {
          filterCategory: item.alias,
        },
      })
    },
    goBack() {
      this.$router.back(-1)
    },
    // onShowSubMenu(item) {
    //   if(item.children && item.children.length > 0 || item.type ==='mega') {
    //     return this.$router.push({name: 'home'})
    //   } else {
    //     return this.$router.push(item.to)
    //   }
    // }
  },
}
</script>
<template>
  <header :class="[$style.header, { [$style.isHomePage]: $route.name === 'home' }, type === 'liff' ? $style.liff : '']">
    <template v-if="type === 'default' || type === 'brand'">
      <div class="header__inner d-none d-lg-block">
        <div class="container--menu">
          <div class="header__headerList">
            <!--Header Mask-->
            <div :data-length="diaplayMenuLength" class="header__mask"></div>
            <!--Header Left-->
            <div class="header__headerLeft">
              <router-link :to="{ name: 'home' }">
                <img alt="logo" class="header__logo" src="@assets/images/logo/logo.svg" />
              </router-link>
            </div>
            <!--Header Right-->
            <div class="header__headerRight">
              <div class="header__headerRightTop">
                <!--第二選單-->
                <ul :class="$style.secondNavList">
                  <li class="secondNavList__item">
                    <router-link class="secondNavList__link" :to="{ name: 'about' }"> 關於零壹 </router-link>
                  </li>
                  <li class="secondNavList__item">
                    <router-link class="secondNavList__link" :to="{ name: 'investor' }"> 投資人專區 </router-link>
                  </li>
                  <li class="secondNavList__item">
                    <router-link class="secondNavList__link" :to="{ name: 'elite' }"> 菁英招募 </router-link>
                  </li>
                  <li class="secondNavList__item">
                    <router-link class="secondNavList__link" :to="{ name: 'contact' }"> 聯絡我們 </router-link>
                  </li>
                </ul>
                <!--工具列-->
                <div :class="$style.toolList">
                  <div class="toolList__item">
                    <BaseButton v-if="loggedIn" class="isStylePrimary isOutline isCircle isSmaller toolList__tool isMember" :to="{ name: 'member' }">
                      <i class="icomoon icon-user"></i>
                    </BaseButton>
                    <BaseButton v-else class="isStyleDark isOutline isCircle isSmaller toolList__tool isLogin" :to="{ name: 'login' }">
                      <i class="icomoon icon-user"></i>
                    </BaseButton>
                  </div>
                  <div class="toolList__item">
                    <BaseButton class="isStylePrimary isCircle isSmaller toolList__tool header__btn" :to="{ name: 'search' }">
                      <img class="header__icon" src="@assets/images/icon/search-line_white.svg" alt="" />
                    </BaseButton>
                  </div>
                </div>
                <!-- 中英頁面切換 -->
                <ul :class="$style.langList">
                  <li class="langList__item">
                    <router-link class="langList__link" :to="{ name: 'en' }"> EN </router-link>
                  </li>
                  <li class="langList__item">
                    <router-link class="langList__link" :to="{ name: 'home' }"> 中文 </router-link>
                  </li>
                </ul>
              </div>
              <div class="header__headerRightBottom">
                <!--主選單-->
                <ul :class="$style.navList">
                  <template v-for="(menuItem, index) in menuList">
                    <li :key="index" class="navList__item" :class="{ hasSubNav: menuItem.children && menuItem.children.length > 0 }">
                      <a v-if="menuItem.type === 'link'" :href="menuItem.path" class="navList__link" target="_blank">
                        {{ menuItem.text }}
                      </a>
                      <router-link v-else-if="menuItem.type === 'insideLink'" class="navList__link" :to="menuItem.to" target="_blank">
                        {{ menuItem.text }}
                      </router-link>
                      <router-link v-else class="navList__link" :to="menuItem.to">
                        {{ menuItem.text }}
                      </router-link>
                      <MegaNav v-if="menuItem.type === 'mega'" class="navList__megaMenu" :title="menuItem.text" :list="menuItem.data.list" :type="menuItem.data.type" />
                      <SubNav v-else-if="menuItem.children && menuItem.children.length > 0" :list="menuItem.children" class="navList__subNav" />
                    </li>
                  </template>
                  <li class="navList__item">
                    <a href="https://www.zerone.com.tw/campaign/2024techinside" class="navList__link">主題策展</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile -->
      <div class="header__inner d-block d-lg-none">
        <div class="header__headerList">
          <!--Header Left-->
          <div v-if="!displayBackkey" class="header__headerLeft" @click="showMobileMenuOpen(!showMobileMenu)">
            <i v-if="showMobileMenu" class="fal fa-fw fa-times header__hambuger"></i>
            <i v-else class="fal fa-fw fa-bars header__hambuger"></i>
          </div>
          <div v-else class="header__headerLeft" @click="goBack">
            <i class="fal fa-long-arrow-left text-3xl color-gray-6"></i>
          </div>
          <!--Header Center-->
          <div class="header__headerCenter">
            <router-link :to="{ name: 'home' }">
              <img v-if="$route.name !== 'home'" alt="logo" class="header__logo" src="@assets/images/logo/logo.svg" />
              <img v-else alt="logo" class="header__logo" src="@assets/images/logo/logo_name.svg" />
            </router-link>
          </div>
          <!--Header Right-->
          <div class="header__headerRight">
            <div :class="$style.toolList">
              <div v-if="!!brandContact.length" class="toolList__item">
                <el-dropdown class="isStyleBase" trigger="click">
                  <BaseButton class="isStylePrimary isSmaller toolList__tool isSearch">
                    <i class="icomoon icon-call color-gray-6 text-xl"></i>
                    <!-- <i class="fal fa-chevron-down ml-2"></i> -->
                  </BaseButton>
                  <el-dropdown-menu slot="dropdown" class="isStylePhone">
                    <el-dropdown-item v-for="(item, $index) in brandContact" :key="$index"
                      >{{ item.name }}{{ item.gender }} ({{ item.countryCode }}){{ item.phone }} {{ item.extension ? `分機 ${item.extension}` : '' }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div v-if="type !== 'brand'" class="toolList__item">
                <BaseButton class="isStylePrimary toolList__tool isSmaller isSearch" @click="mobileSearchOpen(!isMobileSearchOpen)">
                  <i class="icomoon icon-search-line color-primary text-2xl"></i>
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
        <transition name="el-fade-in-linear">
          <MobileSearch v-if="isMobileSearchOpen" @mobileSearchOpen="mobileSearchOpen" />
        </transition>
        <transition name="el-fade-in-linear">
          <div v-if="showMobileMenu" :class="[$style.mobileMenu, { mobileMenu__subMenuPage: subMenuPage.title }]">
            <transition-group name="el-fade-in-linear">
              <div v-show="subMenuPage.title && !productSubMenuPage.title" key="1" class="mobileMenu__subMenuPage">
                <baseButton class="isStylePrimary isTextUnderline mb-4 text-decoration-none" @click="onChangeMenuPage({ title: '', list: [] })">
                  <i class="fal fa-chevron-left"></i>
                  返回上一層
                </baseButton>
                <div class="text-base my-5 text-center">
                  {{ subMenuPage.title.split('-')[0] }} -
                  <span class="font-medium">
                    {{ subMenuPage.title.split('-')[1] }}
                  </span>
                </div>
                <div v-if="subMenuPage.description" class="text-base text-gray-6 mb-4 text-center">
                  {{ subMenuPage.description }}
                </div>
                <ul v-if="subMenuPage.alias === 'products'" :class="$style.subMenuPageList">
                  <li v-for="(subMenuPageItem, $index) in subMenuPage.list" :key="$index" class="subMenuPageList__item d-flex justify-content-between" @click="goToProductCategory(subMenuPageItem)">
                    {{ subMenuPageItem.title }}
                    <i
                      class="fal fa-chevron-right align-self-center pl-2"
                      @click.stop.prevent="
                        onChangeSubMenuPage({
                          title: `${subMenuPage.title.split('-')[1]} - ${subMenuPageItem.title}`,
                          alias: subMenuPage.alias,
                          list: subMenuPageItem.brands,
                          name: subMenuPage.name,
                          category: subMenuPageItem.alias,
                        })
                      "
                    >
                    </i>
                  </li>
                </ul>
                <ul v-else :class="$style.subMenuPageList">
                  <li v-for="(subMenuPageItem, $index) in subMenuPage.list" :key="$index" class="subMenuPageList__item">
                    <router-link class="subMenuPageList__link" :to="goTo(subMenuPageItem.alias)">
                      {{ subMenuPageItem.title }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <!-- second page -->
              <div v-show="productSubMenuPage.title" key="2" class="mobileMenu__subMenuPage">
                <baseButton class="isStylePrimary isTextUnderline mb-4 text-decoration-none" @click="onChangeSubMenuPage({ title: '', list: [] })">
                  <i class="fal fa-chevron-left"></i>
                  返回上一層
                </baseButton>
                <div class="text-base my-5 text-center">
                  {{ productSubMenuPage.title.split('-')[0] }} -
                  <span class="font-medium">
                    {{ productSubMenuPage.title.split('-')[1] }}
                  </span>
                </div>
                <ul :class="$style.subMenuPageList">
                  <li v-for="(subMenuPageItem, $index) in productSubMenuPage.list" :key="$index" class="subMenuPageList__item">
                    <router-link class="subMenuPageList__link" :to="goTo(subMenuPageItem.alias)">
                      {{ subMenuPageItem.title }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <div v-show="!subMenuPage.title" key="3">
                <div class="mb-3 bg-primary color-white text-center login">
                  <template v-if="loggedIn">
                    <div class="text-lg font-medium mb-3">Hi,{{ currentMember.name || '零壹會員' }}</div>
                    <baseButton class="isStyleWhite isRadius isCol3 font-medium" :to="{ name: 'member' }"> 會員中心 </baseButton>
                  </template>
                  <template v-else>
                    <div class="text-xl font-medium mb-3">成為零壹科技會員</div>
                    <baseButton class="isStyleWhite isRadius isCol3 font-medium" :to="{ name: 'login' }"> 登入 / 註冊 </baseButton>
                  </template>
                </div>
                <template v-for="(menuItem, index) in menuList">
                  <MenuToggle :key="index" :item="menuItem" @changeMenuPage="onChangeMenuPage" />
                </template>
                <MenuToggle :item="techInside" />
                <template v-for="(menuItem, index) in mobileMenuList">
                  <MenuToggle :key="index" :item="menuItem" @changeMenuPage="onChangeMenuPage" />
                </template>
                <div class="mt-5">
                  <el-form v-model="email" class="isStyleBase isStyleSubscription" @submit.prevent.native="onSubscription">
                    <el-form-item label="訂閱零壹快訊">
                      <el-input v-model="email" placeholder="輸入您的電子郵件"></el-input>
                    </el-form-item>
                    <BaseButton type="submit" class="isStylePrimary isRadius isFull" :disabled="invalid || tryingSubscription"> 訂閱 </BaseButton>
                  </el-form>
                  <el-divider class="isStyleHeader my-4"></el-divider>
                  <div class="socialMenu text-center">
                    <a v-if="currentSetting.fbFanpageUrl" :href="currentSetting.fbFanpageUrl" target="_blank" class="text-decoration-none socialMenu__item">
                      <i class="fab fa-facebook-square"></i>
                      <span class="sr-only">facebook</span>
                    </a>
                    <a v-if="foramtLineId" :href="`https://line.me/R/ti/p/%40${foramtLineId}`" target="_blank" class="text-decoration-none socialMenu__item">
                      <i class="fab fa-line"></i>
                      <span class="sr-only">line</span>
                    </a>
                    <a v-if="currentSetting.podcast" :href="currentSetting.podcast" target="_blank" class="text-decoration-none socialMenu__item">
                      <i class="far fa-podcast"></i>
                      <span class="sr-only">podcast</span>
                    </a>
                    <a v-if="currentSetting.youtubeUrl" :href="currentSetting.youtubeUrl" target="_blank" class="text-decoration-none socialMenu__item">
                      <i class="fab fa-youtube"></i>
                      <span class="sr-only">youtube</span>
                    </a>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
        </transition>
      </div>
    </template>
    <template v-if="type === 'liff'">
      <div class="header__inner">
        <span>
          <img alt="logo" class="header__logo" src="@assets/images/logo/logo.svg" />
        </span>
      </div>
    </template>
  </header>
</template>
<style lang="scss" module>
.mobileMenu {
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  height: calc(100vh - 70px);
  height: calc((var(--vh, 1vh) * 100) - 48px);
  padding: 2rem $container-gap;
  overflow: auto;
  background: #fff;
  @include max-md {
    top: 48px;
  }
  :global {
    .login {
      position: relative;
      margin: -2rem -19px;
      padding: 20px $container-gap;
    }
  }
  &:global {
    &.mobileMenu {
      &__subMenuPage {
        top: 0;
        z-index: 1035;
        height: 100vh;
        background: #fff;
      }
    }
  }
}

.header {
  position: relative;
  z-index: $z-index-header;
  height: 113px;

  @include max-lg {
    height: 70px;
  }

  @include max-md {
    height: 48px;
  }
  &.isHomePage {
    :global {
      .header__logo {
        @include max-md {
          width: 90px;
          top: -1px;
        }
      }
    }
  }
  :global {
    .header {
      &__logo {
        position: relative;
        top: -8px;
        width: 224px;

        @include max-lg {
          top: -3px;
          width: 166px;
        }

        @include max-lg {
          width: 120px;
        }
      }

      &__inner {
        position: fixed;
        top: 0;
        width: 100%;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(3px);
        box-shadow: 0 10px 20px #25381019;

        &::before {
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          height: 6px;
          content: '';
          background: $color-primary;

          @include max-lg {
            height: 0;
          }
        }

        @include max-lg {
          height: 70px;
          padding-right: $container-gap;
          padding-left: $container-gap;
          background: #f4f6fa;
        }
        @include max-md {
          height: 48px;
        }
        > div.container--menu {
          padding-right: 60px;
          padding-left: 60px;
          // @media screen and (max-width: $container-menu){
          //   padding-right: 60px;
          //   padding-left: 60px;
          // }
        }
      }

      &__mask {
        position: absolute;
        top: 0;
        bottom: 5px;
        left: 0;
        // width: calc(((100vw - #{$container-menu}) / 2) + 800px) ;
        // background: rgba(255,255,255,0.8);

        @for $i from 1 through 6 {
          $fix-width: (6 - $i) * 219;

          &[data-length='#{$i}'] {
            width: calc(((100vw - #{$container-menu}) / 2) + #{800 + $fix-width}px);

            @media screen and (max-width: $container-menu) {
              width: calc(100vw + #{$container-gap * 2} - #{1053 - $fix-width}px);
            }

            /* @include max-xl {
                $fix-width: (6 - $i) * 177;

                width: calc(100vw + #{$container-gap * 2} - #{447 + $fix-width}px);
              } */

            @include max-xl {
              $fix-width: (6 - $i) * 171;
              // background: red;
              width: calc(100vw + #{$container-gap * 2} - #{765 - $fix-width}px);
            }

            @include max-lg {
              $fix-width: (6 - $i) * 135;

              bottom: 4px;
              // background: red;
              width: calc(100vw + #{$container-gap * 2} - #{605 - $fix-width}px);
            }
          }
        }
      }

      &__headerList {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        &::after {
          // position: absolute;
          // top: 0;
          // right: 0;
          // bottom: 5px;
          // width: calc((100vw - #{$container-menu}) / 2 + 30px);
          // content: '';
          // background: rgba(255,255,255,0.8);

          @media screen and (max-width: $container-menu) {
            width: 60px;
          }
        }
      }

      &__headerLeft {
        position: relative;
        padding: 1.3rem 0;

        @include max-lg {
          padding: 1.1rem 0;
        }
        @include max-md {
          padding: 0.5rem 0;
        }
      }

      &__headerRight {
        z-index: 1;
        padding-top: 1.125rem;

        @include max-lg {
          padding-top: 0.45rem;
        }

        @include max-md {
          padding-top: 0;
        }
      }

      &__headerRightTop,
      &__headerRightBottom {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      &__btn {
        padding-left: 0 !important;
      }

      &__icon {
        width: 14px;
        height: 14px;
        margin-top: -2px;
      }

      &__hambuger {
        font-size: 2rem;
        color: $color-primary;
      }
    }
  }
}

.liff {
  :global {
    .header__inner {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 130px;
      @include max-lg {
        height: 70px;
        background: #fff;
        &:before {
          height: 5px;
        }
      }

      @include max-md {
        height: 48px;
      }
    }
  }
}

.toolList {
  display: flex;
  align-items: center;
  min-width: 40px;

  :global {
    .toolList {
      &__item {
        padding: 0 0.5rem;

        &:last-child {
          padding-right: 0;
        }
      }

      &__tool {
        &.isLogin {
          // background-image: url(~@assets/images/icon/user.svg) !important;
          // background-repeat: no-repeat !important;
          // background-position: center !important;
          // background-size: 50% !important;
          // transition: all .3s;
          &:hover {
            // background: none !important;
            // background-image: url(~@assets/images/icon/user_primary.svg) !important;
            // background-repeat: no-repeat !important;
            // background-position: center !important;
            // background-size: 50% !important;
          }
        }
        &.isSearch {
          &:hover,
          &:active {
            background: transparent;
            text-decoration: none;
          }
          background: transparent !important;
          padding: 0;
        }

        &.isMember {
          padding-left: 3px;
          font-size: 0.875rem;
          border: 1px solid $color-primary;
          // color: $color-gray-7;
        }
      }
    }
  }
}
.secondNavList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  margin-right: 0.875rem;
  font-size: 1rem;

  @include max-lg {
    margin-top: 3rem;
    margin-right: 0;
  }

  @include max-md {
    flex-wrap: wrap;
  }

  :global {
    .secondNavList {
      &__item {
        position: relative;

        @include max-lg {
          flex-grow: 1;
          text-align: center;
        }

        @include max-md {
          width: 50%;
          padding: 5px 0;
        }

        &:not(:last-child) {
          &::before {
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 1em;
            content: '';
            background: $color-primary;
            transform: translateY(-50%);
          }
        }

        @include max-md {
          &:not(:nth-child(odd)) {
            &::before {
              display: none;
            }
          }
        }
      }

      &__link {
        padding: 0 1.25rem;
        color: #1d293f;

        @include max-lg {
          font-size: 0.875rem;
        }

        @include max-md {
          font-size: 1rem;
        }

        &:hover {
          color: $color-primary;
          text-decoration: none;
        }

        &.router-link-active {
          color: $color-primary;
        }
      }
    }
  }
}

.langList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  margin-right: -1.25rem;
  font-size: 1rem;

  @include max-lg {
    margin-top: 3rem;
    margin-right: 0;
  }

  @include max-md {
    flex-wrap: wrap;
  }

  :global {
    .langList {
      &__item {
        position: relative;

        @include max-lg {
          flex-grow: 1;
          text-align: center;
        }

        @include max-md {
          width: 50%;
          padding: 5px 0;
        }

        &:not(:last-child) {
          &::before {
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 1em;
            content: '';
            background: $color-primary;
            transform: translateY(-50%);
          }
        }

        @include max-md {
          &:not(:nth-child(odd)) {
            &::before {
              display: none;
            }
          }
        }
      }

      &__link {
        padding: 0 1.25rem;
        color: #1d293f;

        @include max-lg {
          font-size: 0.875rem;
        }

        @include max-md {
          font-size: 1rem;
        }

        &:hover {
          color: $color-primary;
          text-decoration: none;
        }

        &.router-link-active {
          color: $color-primary;
        }
      }
    }
  }
}

.navList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  margin-right: -2.5rem;

  @include max-xl {
    margin-right: -1.2rem;
  }
  // @media screen and (max-width: 1500px) {
  //   margin-right: -1.2rem;
  // }
  :global {
    .navList {
      &__item {
        z-index: 0;
        padding-left: 0;

        &:hover {
          .navList {
            &__megaMenu,
            &__subNav {
              pointer-events: auto;
              opacity: 1;
            }

            &__link {
              color: $color-primary;
              text-decoration: none;

              &::before {
                bottom: 0;
              }
            }
          }
        }

        &.hasSubNav {
          position: relative;
        }
      }

      &__link {
        position: relative;
        top: 2px;
        display: inline-block;
        height: 58px;
        padding: 0.8rem 2.5rem 1rem;
        overflow: hidden;
        color: #1d293f;

        @include max-xl {
          padding-right: 1rem;
          padding-left: 1rem;
        }

        @include max-lg {
          height: 45px;
          padding: 0.7rem 0.75rem 0.6rem;
          font-size: 0.875rem;
        }

        &::before {
          position: absolute;
          right: 0;
          bottom: -15px;
          left: 50%;
          z-index: -1;
          width: 0;
          height: 0;
          content: '';
          border-color: transparent transparent $color-primary transparent;
          border-style: solid;
          border-width: 0 7px 7px 7px;
          // background-image: url('~@assets/images/header/header-bg.png');
          // background-position: bottom center;
          transition: bottom 0.3s;
          transform: translateX(-50%);
        }

        &.router-link-active {
          color: $color-primary;
          &::before {
            bottom: 0 !important;
          }
        }
      }

      &__megaMenu {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        width: 100vw;
        pointer-events: none;
        background: #f5f5f5;
        box-shadow: 0 10px 20px #21455827;
        opacity: 0;
        transition: opacity 0.3s;
        transform: translateY(100%);
      }

      &__subNav {
      }
    }
  }
}

.subMenuPageList {
  @include list-unstyled;
  padding-bottom: 1.5rem;
  :global {
    .subMenuPageList {
      &__item {
        padding: 1rem 2.56rem;
        border-bottom: 1px solid $color-gray-2;
      }

      &__link {
        color: $color-gray-7;

        &:hover {
          color: $color-primary;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
